export { default as RoleStore } from './RoleStore';
export { default as RoleViewStore } from './RoleViewStore';



// WEBPACK FOOTER //
// ./src/modules/role/stores/index.js